import React from 'react'
import { CCol, CFormLabel, CRow } from '@coreui/react-pro'
import TimezoneSelect from 'react-timezone-select'

// Matches the height/border/radius of CoreUI's <CFormSelect> (the "Game Type" dropdown
// right above this field) so the two inputs line up instead of react-select's own defaults.
const timezoneSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderRadius: '0.375rem',
    borderColor: state.isFocused ? '#321fdb' : '#d8dbe0',
    boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(50, 31, 219, 0.25)' : 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#321fdb' : '#d8dbe0',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0.375rem 0.75rem',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  indicatorsContainer: (base) => ({ ...base, height: 38 }),
}

const AboutGame = ({ timezone, setTimezone, disabled }) => {
  const handleTimezoneChange = (selected) => {
    setTimezone(selected.value)
  }
  return (
    <CRow>
      <CCol md={12}>
        <CFormLabel className="fw-bold" htmlFor="Timezone">
          Timezone *
        </CFormLabel>
        <TimezoneSelect
          value={timezone || ''}
          onChange={handleTimezoneChange}
          className="timezone-select"
          styles={timezoneSelectStyles}
          isDisabled={disabled}
        />
        {disabled && (
          <small>
            <i>{`Set when your game was created and can't be changed here.`}</i>
          </small>
        )}
      </CCol>
    </CRow>
  )
}

export default AboutGame
